// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"218":"FillRecordCategoryView","681":"Checkout"}[chunkId] + "." + {"218":"1bf36a6786222cc95a3d","681":"d1240d53bf4fdcc8c8c5"}[chunkId] + ".css";
};